export const wanderWriter = {
  dashboard: {
    title: "My Wanders",
    subtitle: "Create and manage your wander compositions. When ready, submit them for approval.",
    readyForApproval: "Ready for Approval",
    drafts: "Drafts",
    noWanders: "No wanders yet. Create your first one!",
    untitled: "Untitled",
    authRequired: "You must be logged in to access this page.",
    guideTooltip: "Guide: What is a Wander?",
    newWander: "New Wander"
  },
  packs: {
    title: "Assigned wander packs",
    subtitle: "Add and edit wanders in the packs you have been assigned to.",
    addWander: "Add wander",
    noWanders: "No wanders in this pack yet.",
    noneAssigned: "You have not been assigned to any wander packs yet. Contact an administrator to get access."
  },
  table: {
    name: "Name",
    segments: "Segments",
    duration: "Duration",
    status: "Status",
    lastUpdated: "Last Updated",
    actions: "Actions",
    presencing: "Presencing",
    poems: "Poems",
    prompt: "Prompt",
    backingTrack: "Backing Track"
  },
  createDialog: {
    title: "Create New Wander",
    nameLabel: "Wander Name",
    descriptionLabel: "Description (optional)",
    packLabel: "Wander pack",
    packHelp: "New wanders must belong to one of your assigned packs.",
    noPacks: "No assigned packs",
    noPacksHelp:
      "You need an assigned pack before creating a wander. Ask an administrator to assign you to a pack.",
    create: "Create"
  },
  guide: {
    title: "Wander Writer Guide",
    whatIsWander: {
      title: "What a Wander Is",
      description: "A Wander is a short, location-based audio journey.",
      whenListenerBegins: "When a listener begins a Wander:",
      listenerBeginsItems: [
        "a nearby location pin is dropped for them",
        "they walk towards it, guided by audio",
        "on arrival, they hear your prompt"
      ],
      recordingMoment: "You are recording the moment of arrival.",
      promptMeets: "Your prompt meets the listener after:",
      promptMeetsItems: [
        "they have walked a short distance",
        "listened to intention-setting audio",
        "heard poetry while moving"
      ],
      listenerAlready: "This means the listener is already:",
      listenerAlreadyItems: [
        "slowed down",
        "attentive",
        "slightly displaced from habit"
      ],
      yourRole: "Your role is not to guide them there —\nit is to help them notice where they've arrived."
    },
    whatYouAreRecording: {
      title: "What You Are Recording (for now)",
      commissioning: "We are commissioning Arrival Prompts only.",
      eachPrompt: "Each prompt should be:",
      promptRequirements: [
        "spoken audio",
        "30–60 seconds long",
        "recorded as a single, uninterrupted take",
        "addressed directly to the listener (\"you\")"
      ],
      listenerState: "The listener will be standing still or slowing down when they hear you."
    },
    whatPromptDoes: {
      title: "What an Arrival Prompt Does",
      strongPrompt: "A strong arrival prompt:",
      strongPromptItems: [
        "acknowledges that the listener has been taken somewhere",
        "invites noticing of the immediate surroundings",
        "helps the place feel specific without naming it",
        "invites the listener to leave a recording at the location if they wish"
      ],
      goodPrompts: "Good prompts often work with:",
      goodPromptsItems: [
        "thresholds, edges, boundaries",
        "what feels slightly out of place",
        "traces of movement, use, or neglect",
        "contrasts (old/new, fast/slow, inside/outside)"
      ],
      helpingListener: "You are helping the listener meet the place they didn't choose."
    },
    whatNotToDo: {
      title: "What Not to Do",
      pleaseAvoid: "Please avoid:",
      avoidItems: [
        "telling the listener where they are or what it \"means\"",
        "assuming the location is beautiful or significant",
        "reflective questions about life, purpose, or self-improvement",
        "tasks that require leaving the location immediately",
        "poetic abstraction that ignores the physical site"
      ],
      stayGrounded: "Stay grounded in this place, right now."
    },
    toneDelivery: {
      title: "Tone & Delivery",
      aimFor: "Aim for:",
      aimForItems: [
        "calm, present, unhurried",
        "attentive rather than instructive",
        "lightly guiding, not authoritative"
      ],
      pauses: "Pauses are welcome.\nSilence is allowed.\nLess is often more.",
      speakAs: "Speak as if you are standing nearby, not performing."
    },
    recordingNotes: {
      title: "Recording Notes",
      items: [
        "Record in a quiet indoor space if possible",
        "Use a natural speaking voice",
        "Remove bracelets or jangly jewellery when recording",
        "No music or effects",
        "One file per prompt",
        "Minor background texture is fine; clarity matters more than polish."
      ]
    },
    submitting: {
      title: "Submitting Your Prompt",
      upload: "Upload:",
      uploadItems: [
        "your recorded audio file",
        "an optional short note on what kind of arrival you were working with"
      ],
      reviewNote: "All submissions are reviewed by the OVERHEAR team.\nWe may suggest light edits for length, clarity, or tone."
    },
    finalNote: {
      title: "A Final Note",
      relyOnChance: "Wanders rely on chance.",
      promptWillPlay: "Your prompt will play:",
      playItems: [
        "in ordinary places",
        "to people you don't know",
        "at moments you can't predict"
      ],
      trust: "Trust simplicity.\nTrust the place.\nIf you're unsure, submit anyway."
    }
  }
}
